module.exports = __webpack_public_path__ + "media/images/index/edit-3ede05582fcf35bc4f7e3b8a7d9e1da9.svg";